/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
/* eslint-disable @typescript-eslint/dot-notation */
import React, { FC, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { BlockUI } from "../BlockUI";
import { ISearchFAResult } from "../../types/common";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(fas);

export interface IconDetail {
  iconName: string;
  prefix: string;
}

interface IIconPicker {
  show: boolean;
  onClose: () => void;
  onChoose: (icon: IconDetail) => void;
  loading?: boolean;
  data: ISearchFAResult[];
  setSearchKey: (k: string) => void;
}

export const IconPicker: FC<IIconPicker> = ({
  show,
  onClose,
  onChoose,
  setSearchKey,
  loading,
  data,
}) => {
  const [icons, setIcons] = useState<ISearchFAResult[]>([]);
  const handleSelectIcon = (event: any) => {
    onChoose(event);
  };

  useEffect(() => {
    setIcons(data);
  }, [data]);

  useEffect(() => {
    setSearchKey("");
  }, []);

  return (
    <Modal size="lg" className="confirm-modal" show={show} onHide={onClose}>
      <Modal.Body>
        <>
          <div className="row">
            <div className="col-md-12">
              <input
                placeholder="Search..."
                type="text"
                className="form-control"
                onChange={(e) => {
                  setSearchKey(e.target.value);
                }}
              />
            </div>
          </div>
          <BlockUI isBlocked={loading}>
            <div className="row mt-3">
              <div className="col-md-12">
                <div className="fa-container row picker-wrapper">
                  {icons
                    .filter((x) => {
                      return (
                        x.styles?.includes("solid") ||
                        x.styles?.includes("regular")
                      );
                    })
                    .map((x) => {
                      return (
                        <>
                          <div
                            className="col-md-3 mb-2"
                            onClick={() => {
                              handleSelectIcon({
                                prefix: "fas",
                                iconName: x.id,
                              });
                            }}
                          >
                            <div className="fa-item ">
                              <FontAwesomeIcon
                                size="xl"
                                className=""
                                icon={["fas", x.id as IconName]}
                              />
                              <small className="text-center font-h5 mt-2">
                                {x.label}
                              </small>
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>
              </div>
            </div>
          </BlockUI>
        </>
      </Modal.Body>
    </Modal>
  );
};
